exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-overlay[data-v-2c474769]{position:absolute;background-color:rgba(0,0,0,0.25);z-index:1000;top:0;left:0;width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.loading-overlay i[data-v-2c474769]{width:100px;height:100px;font-size:100px\n}\n", ""]);

// exports
